import { ReactElement } from 'react';
import { CustomColumn } from '../../../../types/components/tables/tableTypes';
import GridItem from '../../../layout/GridComponents/GridItem';
import CustomTable from '../../../tables/CustomTable';
import { mainColors } from '../../../../styling/theme';
import { percentageToTwoDecimalPlacesNoHundred } from '../../../../utilities/numberFormatters';
import DisplayAreaCenteredWrapper from '../../../layout/utilities/displayAreaWrapper';
import { useWindowSize } from 'react-use';
import { Typography } from '@mui/material';
import {
  LasdabCplRiskReport,
  LasdabScenarioTable,
  LasdabTableDataRow,
} from './lasdab.types';
// import { fundAssetColumns } from '../fundAssetLiquidationTime/FundAssetLiquidationTimePage';

interface Props {
  fundName: string;
  data: LasdabCplRiskReport | null | undefined;
  isFetching?: boolean;
  stressLevel: string;
}

export interface ILasdabData {
  numDays: number;
  dailyAchievable: string;
  cumulativeAchievable: string;
}

function getStressLevelColour(stressLevel: string) {
  switch (stressLevel) {
    case 'standard':
      return mainColors.mainBlue;
    case 'stressed':
      return mainColors.Alert;
    case 'superStressed':
      return mainColors.Fail;
    default:
      return mainColors.mainBlue;
  }
}
const fundAssetColumns = (stressLevel: string): CustomColumn<ILasdabData>[] => {
  return [
    {
      title: '# Days',
      field: 'numDays',
      width: '33%',
      cellStyle: {
        textAlign: 'center',
      },
      headerStyle: {
        textAlign: 'center',
        color: getStressLevelColour(stressLevel),
      },
    },
    {
      title: 'Daily Achievable',
      field: 'dailyAchievable',
      width: '33%',
      cellStyle: {
        textAlign: 'center',
      },
      headerStyle: {
        textAlign: 'center',
        color: getStressLevelColour(stressLevel),
      },
    },
    {
      title: 'Cumulative Achievable',
      field: 'cumulativeAchievable',
      width: '33%',
      cellStyle: {
        textAlign: 'center',
      },
      headerStyle: {
        textAlign: 'center',
        color: getStressLevelColour(stressLevel),
      },
    },
  ];
};

function buildLasdabTableData(
  inputData: LasdabCplRiskReport | null | undefined,
  level: string,
) {
  const data = inputData?.lasdab;
  if (!data) return [];

  const stressData: LasdabScenarioTable =
    level === 'stressed'
      ? data.stressed
      : level === 'superStressed'
        ? data.super_stressed
        : data.bau;

  const returnData: ILasdabData[] = [];
  const rows = stressData.slice(1) as LasdabTableDataRow[];
  rows.forEach((value) => {
    returnData.push({
      numDays: value[0],
      dailyAchievable: percentageToTwoDecimalPlacesNoHundred(value[1]),
      cumulativeAchievable: percentageToTwoDecimalPlacesNoHundred(value[2]),
    });
  });
  return returnData;
}

function LasdabTable({
  fundName,
  data,
  isFetching,
  stressLevel,
}: Props): ReactElement | null {
  const tableData = buildLasdabTableData(data, stressLevel);

  const columns = fundAssetColumns(stressLevel);

  const { height } = useWindowSize();
  return tableData.length ? (
    <>
      <GridItem xs={3} card>
        <CustomTable<ILasdabData>
          showToolbar={true}
          loading={!!isFetching}
          // csvFields={csvFundAssetLiquidationTime}
          options={{
            paging: false,
            sorting: false,
            maxBodyHeight: height * 0.78,
            exportButton: true,
          }}
          data={tableData}
          columns={columns}
          toolbarComponents={{
            toolbarTitle: fundName,
          }}
        />
      </GridItem>
    </>
  ) : (
    <DisplayAreaCenteredWrapper>
      <Typography variant="h1">{'No Data Available.'}</Typography>{' '}
    </DisplayAreaCenteredWrapper>
  );
}

export default LasdabTable;
